import { slideDown, slideUp } from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const accordionSections = document.querySelectorAll('.job-listing-section');

    accordionSections.forEach((section) => {
        const tabItems = section.querySelectorAll('.jls-item');
        const popupButtons = section.querySelectorAll('.popup-btn');
        const closeButtons = section.querySelectorAll(
            '.jls-form-close, .jls-form-overlay',
        );

        // Open popup
        popupButtons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const popup = section.querySelector('.jls-form-popup');
                if (popup) {
                    popup.classList.add('is-show');
                    document.body.classList.add('scroll-fixed');
                }
            });
        });

        // Close popup
        closeButtons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const popup = section.querySelector('.jls-form-popup');
                if (popup) {
                    popup.classList.remove('is-show');
                    document.body.classList.remove('scroll-fixed');
                }
            });
        });

        // Accordion functionality
        tabItems.forEach((item) => {
            const title = item.querySelector('.jls-title');
            const content = item.querySelector('.jls-desc');

            if (title && content) {
                title.addEventListener('click', () => {
                    const isOpen = item.classList.contains('is-active');

                    // Close other open items
                    tabItems.forEach((sibling) => {
                        if (
                            sibling !== item &&
							sibling.classList.contains('is-active')
                        ) {
                            sibling.classList.remove('is-active');
                            const siblingContent =
								sibling.querySelector('.jls-desc');
                            if (siblingContent) {
                                slideUp(siblingContent); // ✅ correct content to slide up
                            }
                        }
                    });

                    // Toggle current item
                    if (isOpen) {
                        item.classList.remove('is-active');
                        slideUp(content);
                    } else {
                        item.classList.add('is-active');
                        slideDown(content);
                    }
                });
            }
        });
    });
});
